angular.module('picmonicng').component('ltiSelectionComponent', {
  templateUrl: '/templates/app/pages/lti-selection/lti-selection.html',
  bindings: {},
  controller: [
    '$stateParams',
    'Navigation',
    '$sce',
    '$scope',
    '$controller',
    '$modal',
    'Pathways',
    'Tracks',
    'Playlists',
    'UserService',
    '$http',
    'schoolClassResource',
    '$filter',
    function (
      $stateParams,
      Navigation,
      $sce,
      $scope,
      $controller,
      $modal,
      Pathways,
      Tracks,
      Playlists,
      UserService,
      $http,
      schoolClassResource,
      $filter
    ) {
      $scope.ltiSelect = true;
      $controller('SearchController', { $scope: $scope });
      $scope.clearResults = function () {
        $scope.results.cards = [];
        $scope.results.pathways = [];
        $scope.results.page = 1;
        $scope.SearchService.searchTerm = '';
      };

      if (!UserService.user.tos_accepted && !UserService.user.settings.set_email) {
        UserService.showTOSModal();
      }

      if ($stateParams.school_class_id) {
        schoolClassResource.get(
          { school_class_id: $stateParams.school_class_id, school_id: UserService.user.school.id },
          function (response) {
            if (!response.end_date) {
              $modal.open({
                templateUrl: '/templates/app/pages/lti-selection/school-class-update.html',
                controller: [
                  '$scope',
                  function ($scope) {
                    $scope.schoolClass = response;
                  },
                ],
              });
            }
          }
        );
      }

      $scope.sections = Pathways.getv3();

      $scope.playlists = Playlists.query();

      $scope.getPlaylistPicmonics = function (playlist) {
        if (playlist.picmonicsFull || playlist.loadingPicmonics) {
          return;
        }

        playlist.loadingPicmonics = true;

        Playlists.query({
          playlist_id: playlist.playlist_id,
          resource: 'picmonics',
        })
          .$promise.then(data => {
            const column =
              playlist.sort_method === 'a~z' ? 'name' : playlist.sort_method === 'z~a' ? '-name' : 'sort_order';

            playlist.picmonicsFull = $filter('orderBy')(data, column);
          })
          .finally(() => {
            playlist.loadingPicmonics = false;
          });
      };

      $scope.getTracks = function (pathway) {
        if (pathway.tracks) {
          return;
        }
        pathway.tracks = Pathways.queryv3({
          pathway_id: pathway.pathway_id,
          resource: 'tracks',
        });
      };

      $scope.getPicmonics = function (track) {
        if (track.cards) {
          return;
        }

        track.cards = Tracks.get({
          track_id: track.track_id,
          resource: 'picmonics',
        });
      };

      var ctrl = this;
      Navigation.topVisible = false;
      ctrl.submitUrl = $sce.trustAsResourceUrl($stateParams.launch_presentation_return_url);
      ctrl.lti_id = $stateParams.lti_id;
      ctrl.request_id = $stateParams.request_id;
      ctrl.context_id = $stateParams.context_id;
      ctrl.d2l = $stateParams.d2l;
      ctrl.data = $stateParams.data;
      ctrl.launch_id = $stateParams.launch_id;
      ctrl.ltiAdvantage = !!$stateParams.launch_id;
      ctrl.UserService = UserService;
      ctrl.base_asset_url = window.pls_config.base_asset_url.substring(
        window.pls_config.base_asset_url.indexOf('/cloud_data')
      );

      function getContentItem(key, url, title, maxScore) {
        return {
          '@context': 'http://purl.imsglobal.org/ctx/lti/v1/ContentItem',
          '@graph': [
            {
              '@type': 'LtiLinkItem',
              '@id': key,
              'url': url,
              'title': title,
              'text': title,
              'mediaType': 'application/vnd.ims.lti.v1.ltilink',
              'displayWidth': 854,
              'displayHeight': 480,
              'icon': {
                '@id': 'https://cdn.picmonic.com/cloud_data/production/assets/img/app_icon.png',
                'height': 50,
                'width': 50,
              },
              'lineItem': {
                '@type': 'LineItem',
                'label': title,
                'reportingMethod': 'res:totalScore',
                'assignedActivity': {
                  '@id': url,
                  'activityId': key,
                },
                'scoreConstraints': {
                  '@type': 'NumericLimits',
                  'normalMaximum': maxScore,
                  'extraCreditMaximum': 0,
                  'totalMaximum': maxScore,
                },
              },
              'placementAdvice': {
                displayWidth: 854,
                displayHeight: 480,
                presentationDocumentTarget: 'iframe',
              },
            },
          ],
        };
      }

      function showLink(link) {
        $modal.open({
          template:
            '<div class="modal-header bg-pls-platinum" ><i class="material-icons pull-right pls-wet-cement" role="button" tabindex="0" ng-click="$dismiss()">close</i> <span>LTI Link</span> </div>\
          <div class="modal-body">\
          <div class="input-group">\
            <input\
              referral-link\
              type="text"\
              readonly\
              value="{{ltiLink}}"\
              class="pls-input pls-input--light form-control"\
            />\
            <span class="input-group-btn">\
              <button\
                clipboard\
                clipboard-text="{{ltiLink}}"\
                copy-button\
                success-message="Link Copied!"\
                class="pls-btn"\
                type="button"\
              >\
                COPY LINK\
              </button>\
            </span>\
        </div>\
        </div>',
          size: 'md',
          controller: [
            '$scope',
            function ($scope) {
              $scope.ltiLink = link;
            },
          ],
        });
      }

      function submitPlaylistContentItem(key, resource, resourceId, url, name, maxScore) {
        if ($stateParams.no_lms) {
          showLink(url);
          return;
        }
        if (!ctrl.ltiAdvantage) {
          var item = getContentItem(key, url, name, maxScore);
          document.content_selection.content_items.value = ctrl.d2l
            ? resource + '-' + resourceId + ',' + maxScore
            : JSON.stringify(item);
        } else {
          document.content_selection.picmonic_resource_type.value = resource;
          document.content_selection.picmonic_resource_id.value = resourceId;
          document.content_selection.picmonic_author_id.value = UserService.user.user_id;
          document.content_selection.picmonic_play_only.value = 'false';
          document.content_selection.picmonic_title.value = name;
          document.content_selection.picmonic_num_questions.value = maxScore;
        }
        document.content_selection.submit();
      }

      ctrl.showSettingsModal = function () {
        $modal.open({
          templateUrl: '/templates/modals/lti-settings.html',
          windowClass: 'prequiz-modal lti-select',
          size: 'sm',
          backdrop: 'static',
          keyboard: false,
          controller: [
            '$scope',
            function ($scope) {
              if (UserService.user.settings && UserService.user.settings.lti_play_only) {
                $scope.play_only = UserService.user.settings.lti_play_only;
              }

              $scope.save = function () {
                UserService.user.settings.lti_play_only = $scope.play_only;
                UserService.user.$update();
              };
            },
          ],
        });
      };

      ctrl.submitPicmonic = function (picmonic, values) {
        var url =
          'https://' +
          location.host +
          '/login/lti?picmonic_id=' +
          picmonic.card_id +
          '&author_id=' +
          UserService.user.user_id +
          '&play_only=' +
          values.play_only;

        if ($stateParams.no_lms) {
          showLink(url);
          return;
        }

        if (!ctrl.ltiAdvantage) {
          var item = getContentItem('picmonic-' + picmonic.card_id, url, picmonic.name, picmonic.num_facts);
          document.content_selection.content_items.value = ctrl.d2l
            ? 'picmonic-' + picmonic.card_id + ','
            : JSON.stringify(item);
        } else {
          document.content_selection.picmonic_resource_type.value = 'picmonic';
          document.content_selection.picmonic_resource_id.value = picmonic.card_id;
          document.content_selection.picmonic_author_id.value = UserService.user.user_id;
          document.content_selection.picmonic_play_only.value = values.play_only;
          document.content_selection.picmonic_title.value = picmonic.name;
          document.content_selection.picmonic_num_questions.value = picmonic.num_facts;
        }
        document.content_selection.submit();
      };

      ctrl.selectPicmonic = function (picmonic) {
        if (UserService.user.settings.lti_play_only) {
          ctrl.submitPicmonic(picmonic, {
            play_only: UserService.user.settings.lti_play_only,
          });
          return;
        }

        $modal
          .open({
            templateUrl: '/templates/modals/lti-lesson-options.html',
            windowClass: 'prequiz-modal lti-select',
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
            controller: [
              '$scope',
              function ($scope) {
                $scope.play_only = 'false';
                $scope.remember = false;
              },
            ],
          })
          .result.then(function (values) {
            if (values.remember) {
              UserService.user.settings.lti_play_only = values.play_only;
              UserService.user.$update();
            }
            ctrl.submitPicmonic(picmonic, values);
          });
      };

      ctrl.selectPlaylist = function (playlist) {
        var maxScore;
        $modal
          .open({
            templateUrl: '/templates/modals/quiz-limit-lti.html',
            windowClass: 'prequiz-modal lti-select',
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
            controller: [
              '$scope',
              function ($scope) {
                $scope.num_questions = Math.min(playlist.total_facts, 20);
                $scope.pathway = playlist;
              },
            ],
          })
          .result.then(function (values) {
            maxScore = values.num_questions;
            if (values.quiz_only == '1') {
              return values;
            } else {
              return $http.post('/api/v3/lti_lessons', {
                resource_type: 'playlist',
                resource_id: playlist.playlist_id,
                total_facts: maxScore,
                lti_id: ctrl.lti_id,
                context_id: ctrl.context_id,
              });
            }
          })
          .then(function (values) {
            if (values.data) {
              var key = 'lesson-' + values.data.lti_lesson_id;
              var resource = 'lesson';
              var resourceId = values.data.lti_lesson_id;
              var url =
                'https://' +
                location.host +
                '/login/lti?lesson_id=' +
                values.data.lti_lesson_id +
                '&author_id=' +
                UserService.user.user_id;
              var name = values.data.resource.name;
            } else {
              var key = 'playlist-' + playlist.playlist_id;
              var resource = 'playlist';
              var resourceId = playlist.playlist_id;
              var url =
                'https://' +
                location.host +
                '/login/lti?questions=' +
                values.num_questions +
                '&playlist_id=' +
                playlist.playlist_id +
                '&author_id=' +
                UserService.user.user_id;
              var name = playlist.name;
            }
            submitPlaylistContentItem(key, resource, resourceId, url, name, maxScore);
          });
      };
      ctrl.selectPathway = function (pathway) {
        var maxScore;
        $modal
          .open({
            templateUrl: '/templates/modals/quiz-limit-lti.html',
            windowClass: 'prequiz-modal lti-select',
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
            controller: [
              '$scope',
              function ($scope) {
                $scope.num_questions = Math.min(pathway.total_facts || pathway.fact_count, 20);
                $scope.pathway = pathway;
              },
            ],
          })
          .result.then(function (values) {
            maxScore = values.num_questions;
            if (values.quiz_only == '1') {
              return values;
            } else {
              return $http.post('/api/v3/lti_lessons', {
                resource_type: pathway.track_id ? 'track' : 'pathway',
                resource_id: pathway.track_id ? pathway.track_id : pathway.pathway_id,
                total_facts: maxScore,
                lti_id: ctrl.lti_id,
                context_id: ctrl.context_id,
              });
            }
          })
          .then(function (values) {
            if (values.data) {
              var key = 'lesson-' + values.data.lti_lesson_id;
              var resource = 'lesson';
              var resourceId = values.data.lti_lesson_id;
              var url =
                'https://' +
                location.host +
                '/login/lti?lesson_id=' +
                values.data.lti_lesson_id +
                '&author_id=' +
                UserService.user.user_id;
              var name = values.data.resource.name;
            } else {
              var key = pathway.track_id ? 'track-' + pathway.track_id : 'pathway-' + pathway.pathway_id;
              var resource = pathway.track_id ? 'track' : 'pathway';
              var resourceId = pathway.track_id ? pathway.track_id : pathway.pathway_id;
              var url =
                'https://' +
                location.host +
                '/login/lti?questions=' +
                values.num_questions +
                '&' +
                (pathway.track_id ? 'track' : 'pathway') +
                '_id=' +
                (pathway.track_id ? pathway.track_id : pathway.pathway_id) +
                '&author_id=' +
                UserService.user.user_id;
              var name = pathway.name;
            }
            submitPlaylistContentItem(key, resource, resourceId, url, name, maxScore);
          });
      };
    },
  ],
});
